// Ficha de producto: los colores cambian la variante seleccionada del formulario real de Shopify.
// Sin JavaScript el <select name="id"> sigue funcionando y el formulario se envía igual.
(function () {
  var root = document.querySelector('[data-pb-product]');
  if (!root) return;
  root.classList.add('pb-js');

  var select = root.querySelector('[data-pb-select]');
  var data = {};
  try { data = JSON.parse(root.querySelector('[data-pb-variants]').textContent); } catch (e) { return; }
  if (!select) return;

  var stage = root.querySelector('[data-pb-stage]');
  var image = root.querySelector('[data-pb-image]');
  var word = root.querySelector('[data-pb-word]');
  var price = root.querySelector('[data-pb-price]');
  var was = root.querySelector('[data-pb-was]');
  var badge = root.querySelector('[data-pb-badge]');
  var submit = root.querySelector('[data-pb-submit]');
  var ask = root.querySelector('[data-pb-ask]');
  var note = root.querySelector('[data-pb-note]');

  function apply(id) {
    var v = data[id];
    if (!v) return;
    select.value = id;
    if (stage && v.color) stage.setAttribute('data-color', v.color);
    if (word) word.textContent = v.title;
    if (image && v.image) { image.src = v.image; image.alt = v.alt || v.title; }
    if (price) price.textContent = v.price;
    if (was) { was.textContent = v.compare || ''; was.hidden = !v.compare; }
    if (badge) {
      badge.textContent = v.available ? 'Disponible' : 'Sin stock por ahora';
      if (v.available) { badge.removeAttribute('data-out'); } else { badge.setAttribute('data-out', ''); }
    }
    if (submit) {
      submit.disabled = !v.available;
      submit.querySelector('[data-pb-submit-text]').textContent = v.available ? 'Agregar al carro' : 'Sin stock';
    }
    if (ask && ask.dataset.base) ask.href = ask.dataset.base + encodeURIComponent(' ' + v.title + '.');
    if (note) note.hidden = !v.warn;
    root.querySelectorAll('[data-pb-variant]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.pbVariant === id));
    });
    root.querySelectorAll('[data-pb-thumb]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.pbThumb === id));
    });
  }

  root.addEventListener('click', function (ev) {
    var b = ev.target.closest('[data-pb-variant],[data-pb-thumb]');
    if (!b || !root.contains(b)) return;
    ev.preventDefault();
    apply(b.dataset.pbVariant || b.dataset.pbThumb);
  });
  select.addEventListener('change', function () { apply(select.value); });
  apply(select.value);
})();
